import React from 'react';
import PropTypes from 'prop-types';
import ReactionArticle from '@src/js/Components/Base/Reaction/ReactionArticle';

class Reaction extends React.Component {

    static get propTypes() {

        return {
            type: PropTypes.string,
        };
    }

    render() {

        switch (this.props.type) {

        case 'article':
            return <ReactionArticle />;

        default:
            throw new Error(`Unknown reaction type: ${this.props.type}`);
        }
    }

}

export default Reaction;